import { useLanguage } from "@/contexts/LanguageContext";

export default function LanguageSwitcher() {
  const { lang, setLanguage } = useLanguage();

  return (
    <div
      className="flex items-center rounded-full border p-0.5"
      style={{ borderColor: "rgba(26,92,55,0.2)", backgroundColor: "rgba(26,92,55,0.04)" }}
    >
      <button
        onClick={() => setLanguage("en")}
        className="px-3 py-1 rounded-full text-xs font-medium transition-all duration-150"
        style={{
          backgroundColor: lang === "en" ? "#1A5C37" : "transparent",
          color: lang === "en" ? "#F7F5F0" : "#4A5450",
        }}
      >
        EN
      </button>
      <button
        onClick={() => setLanguage("kn")}
        className="px-3 py-1 rounded-full text-xs font-medium transition-all duration-150"
        style={{
          backgroundColor: lang === "kn" ? "#1A5C37" : "transparent",
          color: lang === "kn" ? "#F7F5F0" : "#4A5450",
          fontFamily: "sans-serif",
        }}
      >
        ಕನ್ನಡ
      </button>
    </div>
  );
}
